/**
 * @fileoverview GET handler for the "/api/calculated_attributes/:id/:app_group_id" endpoint
 */
import fetch from "@lib/fetch";

import { createGetFetcherFunctionWithShadowError } from "../reactQueryFetcherAdapters/createGetFetcherFunctionWithShadowError";
import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { apiCalculatedAttributesIdAppGroupId } from "./constants";
import type {
  GetApiCalculatedAttributesIdAppGroupIdResult,
  GetApiCalculatedAttributesIdAppGroupIdResultErrors,
} from "./types";
import { isGetApiCalculatedAttributesIdAppGroupIdResult } from "./validators";

export const getApiCalculatedAttributesIdAppGroupId = reactQueryFetcherAdapter(
  apiCalculatedAttributesIdAppGroupId,
  createGetFetcherFunctionWithShadowError<GetApiCalculatedAttributesIdAppGroupIdResultErrors>()(
    (
      signal: AbortSignal,
      id: string,
      appGroupId: string
    ): Promise<GetApiCalculatedAttributesIdAppGroupIdResult> => {
      return fetch(`/api/calculated_attributes/${id}/${appGroupId}`, "GET", {}, { signal });
    }
  ),
  isGetApiCalculatedAttributesIdAppGroupIdResult
);
